import { Skeleton, Text, Tooltip } from "components/common"
import { Separator } from "components/custom"
import { t } from "i18next"
import { joinBytItems, localisedValue } from "utils"
import theme from "utils/themeVars"
export function buildInvestmentProfilingRows(profiling) {
  const emptySummary = () => ({
    first: "",
    restCount: 0,
    tooltipTitle: "",
    isEmpty: true,
  })

  const displayValue = entity => (entity ? localisedValue({ object: entity, key: "displayValue" }) || "" : "")

  const rawCapitalStructure = (capitalStructure, targetPercentEntity) => {
    const base = displayValue(capitalStructure)
    const percentage = targetPercentEntity?.displayValue ?? targetPercentEntity
    return joinBytItems([base, percentage], <Separator />)
  }

  const summaryCommaSeparatedValue = text => {
    if (text == null || String(text).trim() === "") return emptySummary()
    const parts = String(text)
      .split(",")
      .map(s => s.trim())
      .filter(Boolean)
    if (parts.length === 0) return emptySummary()
    return {
      first: parts[0],
      restCount: parts.length - 1,
      tooltipTitle: parts.join(", "),
      isEmpty: false,
    }
  }

  const label = (entity, fallbackKey) => localisedValue({ object: entity, key: "label" }) || t(fallbackKey)

  const profile = profiling
  const capitalStructure = profile?.capitalStructure
  const targetCapitalReturnPercent = profile?.targetCapitalReturnPercent

  return [
    {
      key: "investmentStrategy",
      label: label(profile?.investmentStrategy, "Investment Strategy"),
      ...summaryCommaSeparatedValue(displayValue(profile?.investmentStrategy)),
    },
    {
      key: "assetClass",
      label: label(profile?.assetClass, "Asset Class"),
      ...summaryCommaSeparatedValue(displayValue(profile?.assetClass)),
    },
    {
      key: "capitalStructure",
      label: label(capitalStructure, "Capital Structure"),
      ...summaryCommaSeparatedValue(rawCapitalStructure(capitalStructure, targetCapitalReturnPercent)),
    },
    {
      key: "riskProfile",
      label: label(profile?.riskProfile, "Risk Profile"),
      ...summaryCommaSeparatedValue(displayValue(profile?.riskProfile)),
    },
  ]
}

export function GetProfilineValue({ row, loading }) {
  if (loading) {
    return <Skeleton active paragraph={{ rows: 1 }} />
  }
  if (row.isEmpty) {
    return <Text className="fs14 gray-900">{""}</Text>
  }

  return (
    <Tooltip title={row.restCount > 0 ? row.tooltipTitle : undefined}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
        <Text className="fs14 gray-900">{row.first || ""}</Text>
        {row.restCount > 0 ? (
          <Text className="fs14" style={{ color: theme["primary-color"], fontWeight: 600 }}>
            {`+${row.restCount}`}
          </Text>
        ) : null}
      </span>
    </Tooltip>
  )
}
